import { setSelContainerNode, getSelContainerNode } from '@/libs/util'

export default {
  state: {
    selContainerNodes: getSelContainerNode()
  },
  mutations: {
    setSelContainerNodes (state, nodes) {
      state.selContainerNodes = nodes
      setSelContainerNode(nodes)
    }
  },
  actions: {
    // 保存选择的Nodes
    saveSelContainerNodes ({ commit }, nodes) {
      commit('setSelContainerNodes', nodes)
    }
  }
}
